import { render, staticRenderFns } from "./TransModal.vue?vue&type=template&id=c6226ede&scoped=true"
import script from "./TransModal.vue?vue&type=script&lang=js"
export * from "./TransModal.vue?vue&type=script&lang=js"
import style0 from "./TransModal.vue?vue&type=style&index=0&id=c6226ede&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6226ede",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6226ede')) {
      api.createRecord('c6226ede', component.options)
    } else {
      api.reload('c6226ede', component.options)
    }
    module.hot.accept("./TransModal.vue?vue&type=template&id=c6226ede&scoped=true", function () {
      api.rerender('c6226ede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data/components/Modal/TransModal.vue"
export default component.exports